module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst data = rowResourceData || {}\nconst attributes = data.attributes || {}\nconst {\nstatusOutDated,\namIAssigned,\nisOneAssigned,\nlastInnerCoreUpdateAt,\nlastCoreUpdateAt,\n} = attributes\nconst status = attributes[model.fieldCode || 'status']\nconst additionalClasses = []\nconst {\nshowTextExplanation\n} = model.config || {}\nlet statusExplanationType = 'valid'\nlet symbol = ''\nif(status){\nsymbol = `fi fi-${status}`\nif(status === 'revoked'){\nadditionalClasses.push('negative')\n} else {\nadditionalClasses.push('positive')\n}\nif(\nstatusOutDated ||\n(\namIAssigned &&\nstatus !== 'agreed' &&\nstatus !== 'revoked'\n) ||\n(\n!amIAssigned &&\nisOneAssigned &&\nstatus !== 'waitlisted' &&\nstatus !== 'revoked'\n)\n){\nadditionalClasses.push('statusOutDated')\nstatusExplanationType = 'statusOutDated'\n}\n} else {\nadditionalClasses.push('new')\n}\nlet explanationDate, explanationDateFormatted = {}\nif(statusExplanationType === 'statusOutDated' && status === 'agreed'){\nexplanationDate = lastCoreUpdateAt\n} else {\nexplanationDate = lastInnerCoreUpdateAt\n}\nif(explanationDate){\nconst m = utils.moment(explanationDate)\nexplanationDateFormatted = {\ndate: m.format('DD.MM.YYYY'),\ntime: m.format('HH:mm')\n}\n}\n%><div class=\"<%= additionalClasses.join(' ') %>\"><%\n%><i class=\"<%= symbol || 'fi fi-circle-question' %>\"></i><%\nif(showTextExplanation){\n%><div class=\"text\"><%\n%><div class=\"status\"><%= storage.__(`advertisements.status.${status || 'none'}`) %></div><%\n%><div class=\"explanation\"><%- storage.__(`advertisements.status.explanation.${statusExplanationType}`, { ...explanationDateFormatted }) %></div><%\n%></div><%\n}\n%></div>"
  , __filename = "components/templates/core/table/fields/advertisementStatus.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const data = rowResourceData || {}
const attributes = data.attributes || {}
const {
statusOutDated,
amIAssigned,
isOneAssigned,
lastInnerCoreUpdateAt,
lastCoreUpdateAt,
} = attributes
const status = attributes[model.fieldCode || 'status']
const additionalClasses = []
const {
showTextExplanation
} = model.config || {}
let statusExplanationType = 'valid'
let symbol = ''
if(status){
symbol = `fi fi-${status}`
if(status === 'revoked'){
additionalClasses.push('negative')
} else {
additionalClasses.push('positive')
}
if(
statusOutDated ||
(
amIAssigned &&
status !== 'agreed' &&
status !== 'revoked'
) ||
(
!amIAssigned &&
isOneAssigned &&
status !== 'waitlisted' &&
status !== 'revoked'
)
){
additionalClasses.push('statusOutDated')
statusExplanationType = 'statusOutDated'
}
} else {
additionalClasses.push('new')
}
let explanationDate, explanationDateFormatted = {}
if(statusExplanationType === 'statusOutDated' && status === 'agreed'){
explanationDate = lastCoreUpdateAt
} else {
explanationDate = lastInnerCoreUpdateAt
}
if(explanationDate){
const m = utils.moment(explanationDate)
explanationDateFormatted = {
date: m.format('DD.MM.YYYY'),
time: m.format('HH:mm')
}
}

    ; __line = 58
    ; __append("<div class=\"")
    ; __append(escapeFn( additionalClasses.join(' ') ))
    ; __append("\">")
    ; 

    ; __line = 59
    ; __append("<i class=\"")
    ; __append(escapeFn( symbol || 'fi fi-circle-question' ))
    ; __append("\"></i>")
    ; 
if(showTextExplanation){

    ; __line = 61
    ; __append("<div class=\"text\">")
    ; 

    ; __line = 62
    ; __append("<div class=\"status\">")
    ; __append(escapeFn( storage.__(`advertisements.status.${status || 'none'}`) ))
    ; __append("</div>")
    ; 

    ; __line = 63
    ; __append("<div class=\"explanation\">")
    ; __append( storage.__(`advertisements.status.explanation.${statusExplanationType}`, { ...explanationDateFormatted }) )
    ; __append("</div>")
    ; 

    ; __line = 64
    ; __append("</div>")
    ; 
}

    ; __line = 66
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/table/fields/advertisementStatus.ejs

}